import {CALL_API} from 'redux/middleware/api'
import {
  UNSUBSCRIBE
} from './'

export function unsubscribe(secret, type) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: 'unsubscribe',
      errorsHandled: true,
      types: UNSUBSCRIBE,
      body: {
        secret,
        type
      }
    }
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/unsubscribe/actions.js